const mapQuantityToSend = ({
  amount,
  lotNumber,
  expirationDate
}) => ({
  amount,
  lotNumber: lotNumber.trim(),
  expirationDate
})

const mapProductToApi = ({
  id,
  isDangerousGoods,
  quantitiesToSend
}) => ({
  id,
  isDangerousGoods,
  quantityToSendRequest: quantitiesToSend.map(mapQuantityToSend)
})

export const mapProductsToApi = ({
  products,
  id
}) => ({
  data: {
    products: products.map(mapProductToApi)
  },
  id
})
